import { Col, FormSection, Row } from "twyne-new.ui"

import MessageContainer from './MessageContainer'
import Options from "./Options"
import TabItem from "./TabItem"
import props from './props'

export default function DatasourceTab({ data, containerMessage }) {
  if (!data) return <MessageContainer message={containerMessage} />

  return <Row>
    <TabItem label="success" value={data.success.toString()} />
    <TabItem label="error" value={data.error} />
    <Col size="12">
      <FormSection>Options</FormSection>
      <Options data={data.options} />
    </Col>
  </Row>
}

DatasourceTab.propTypes = props
DatasourceTab.defaultProps = {}
